import React from 'react';

/**
 * 可选参数
 */
interface IProps {
	site?: any;
}

/**
 * 页脚
 */
class LayoutFooter extends React.PureComponent<IProps> {
	/**
	 * render
	 */
	public render(): any {
		return (
			<div className="p-layout-footer">
				<div className="relevant">
					<ul>
						<li>产品</li>
						<li>
							<a href="https://pc.qlchat.com/official/introduction">功能介绍</a>
						</li>
						<li>
							<a href="https://pc.qlchat.com/official/price">专业版</a>
						</li>
						<li>
							<a href="https://pc.qlchat.com/official/student">我是学员</a>
						</li>
					</ul>
					<ul>
						<li>服务</li>
						<li>
							<a href="https://mp.weixin.qq.com/mp/homepage?__biz=MzU4NjMyMDQwOA==&hid=10&sn=5eb52577a9902f0f6d6bb3b8574d1470&uin=&key=&devicetype=Windows+10&version=62060833&lang=zh_CN&ascene=1&winzoom=1.125&scene=1">产品教程</a>
						</li>
						<li>
							<a href="https://mp.weixin.qq.com/s/B3wg0AjGvN1BUmiW_-bEfQ">常见问题</a>
						</li>
						<li>
							<a href="https://m.qlchat.com/wechat/page/live/100000081018489?wcl=seo">讲师学院</a>
						</li>
						<li>
							<a href="https://m.qlchat.com/video/admin/live/select?wcl=seo">管理后台</a>
						</li>
					</ul>
					<ul>
						<li>关于千聊</li>
						<li>
							<a href="https://pc.qlchat.com/official/about">公司简介</a>
						</li>
						<li>
							<a href="https://mp.weixin.qq.com/s?__biz=MzA4MTk0OTY1MQ==&mid=100002267&idx=1&sn=a64845ba9e722f6689a099b1fee72ac3&scene=19#wechat_redirect">市场合作</a>
						</li>
						<li>
							<a href="https://www.liepin.com/company/8975743">加入我们</a>
						</li>
						<li>
							<a href="https://m.qlchat.com/privacy_policy.html">隐私协议</a>
						</li>
					</ul>
					<ul>
						<li>联系我们</li>
						<li>电话：020-88525535 (工作日9:30 - 19:00)</li>
						<li>
							地址：广州市天河区棠下街道棠东东路27、29号中盛棠东汇A506
							<br />
						</li>
					</ul>
					<div className="qr-box">
						<img src="https://img.qlchat.com/qlLive/activity/image/C1W3V3GI-TVLB-JOET-1604901796523-4ARIZLEG7K4W.png" alt="" />
						<p>
							扫码立即下载
							<br />
							领取新人大礼包
						</p>
					</div>
				</div>
				<div className="copyright">
					<p>copyright C 2016-2022 www.qlchat.com inc. All Right Reserved 广州思坞信息科技有限公司 版权所有</p>
					<p>
						<span>
							<a href="https://beian.miit.gov.cn/">粤ICP备15102474号-3</a>
						</span>
						<span>
							<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602002623">粤公网安备 44010602002623号</a>
						</span>
						<span>
							<a href="http://img.qlchat.com/qlLive/liveCommon/wangwenzheng.jpg">粤网文【2020】4310-268号</a>
						</span>
						<span>
							<a href="https://img.qlchat.com/qlLive/activity/image/2QUP81XW-SKBQ-WQDL-1567523544542-3DP73C2P65ON.jpg">增值电信业务经营许可证：粤B2-20191058</a>
						</span>
						<span>
							<a href="http://www.gdis.cn/">互联网清理整顿</a>
						</span>
					</p>
				</div>
			</div>
		);
	}
}

export default LayoutFooter;
